export function DialogHost() {
  return (
    <>
    <dialog id={"dialog"} class={"dialog"}>
      <div class={"dialog-shell"} id={"dialog-shell"}>
        <header>
          <div>
            <span class={"dialog-kicker"}>
              {"kUni"}
            </span>
            <h3 id={"dialog-title"}></h3>
          </div>
          <button class={"icon-button"} type={"button"} id={"dialog-close"} data-ui-text-aria={"shell.dialog.close"}>
            <svg viewBox={"0 0 24 24"}>
              <path d={"M6 6l12 12M18 6 6 18"}></path>
            </svg>
          </button>
        </header>
        <div id={"dialog-body"} class={"dialog-body"}></div>
        <footer id={"dialog-footer"}></footer>
      </div>
    </dialog>
    <div id={"toast"} class={"toast"} role={"status"} aria-live={"polite"} hidden></div>
    </>
  );
}
